import moment from "moment";
import { formatToCurrency } from "utils/currency";
import { AssetItem } from "./AssetItem";
import { formatPhone } from "shared/utils";

export const DynamicValue = ({
  detailsKey: key,
  value,
  fullDate,
  assetName
}: {
  detailsKey: string;
  value: any;
  fullDate?: boolean;
  assetName?: string;
}) => {
  if (!key) return "--";

  if (typeof value === "undefined" || value === null) return "--";

  const normalizedKey = key.toLowerCase();

  if (
    ["Y", "Yes", "yes", "y", "true"].includes(value) ||
    (typeof value === "boolean" && value)
  )
    return "Yes";

  if (
    ["N", "No", "no", "n", "false"].includes(value) ||
    (typeof value === "boolean" && !value)
  )
    return "No";

  if (normalizedKey.includes("date") && !isNaN(Date.parse(value)))
    if (fullDate) return moment(value).format("ll");
    else return moment(value).format("MMM YYYY");

  if (
    (value?.asset && value.asset?.url && value.asset?.content_type) ||
    (normalizedKey === "asset" && value.url && value.content_type)
  )
    return (
      <AssetItem
        url={value.asset?.url || value?.url}
        content_type={value?.asset?.content_type || value?.content_type}
        filename={value.asset?.filename || value?.filename}
        assetName={assetName}
      />
    );

  if (normalizedKey.includes("phone")) return formatPhone(value);

  if (
    typeof value === "number" &&
    (normalizedKey.includes("amount") ||
      normalizedKey.includes("fee") ||
      normalizedKey.includes("cents") ||
      normalizedKey.includes("income") ||
      normalizedKey.includes("payment"))
  )
    return normalizedKey.includes("cents")
      ? formatToCurrency(
          { cents: value, currency: "USD" },
          { maximumFractionDigits: 0 }
        )
      : formatToCurrency(
          { cents: value * 100, currency: "USD" },
          { maximumFractionDigits: 0 }
        );

  return value;
};
